import React from 'react'
import { Container } from '@mui/material';
import About from './startpage/about'; // not restored
import { useState, useEffect } from 'react';
import axios from 'axios';
import SEO from './seo/seo';

import { backend } from '../statics/system_variables'


export default function AboutPage() {

    const [data, setData] = useState({ dogs: {}, shelters: 0, breeds: 0, count: 0 });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        var api_link = backend + '/starting'

        axios.get(api_link)
            .then(({ data }) => {
                setData(data)
                setLoading(false)
            }).catch((error) => {

            })
    }, [])

    
    return (
        <>
            <SEO
                title={"Über das online Hundeheim - PocketPet"}
                description={'PocketPet ist eine zeitgemäße Online-Hundevermittlung. Du verdienst einen Hund, der deinen Vorstellungen entspricht. Er wartet in einem deutschen Tierheim auf dich.'}
                type='website' />

            <Container maxWidth="xl">
                <About loading={loading} data={data} />
            </Container>
        </>

    )
}
